"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRetryRequest = exports.shouldRevalidateInstance = exports.backoffDelay = exports.isRetryableError = exports.isNetworkError = exports.isIdempotentMethod = exports.RETRY_CONFIG_DEFAULT = void 0;
var REVALIDATE_STATUSES = [401, 403];
var RETRY_STATUS_RANGES = [
    [429, 429],
    [500, 599],
];
var IDEMPOTENT_HTTP_METHODS = ['get', 'head', 'options', 'put', 'delete'];
// taken from https://github.com/sindresorhus/is-retry-allowed
var RETRY_ERROR_CODES = [
    'ECONNABORTED',
    'ETIMEDOUT',
    'ECONNRESET',
    'EADDRINUSE',
    'ESOCKETTIMEDOUT',
    'ECONNREFUSED',
    'EPIPE',
    'EHOSTUNREACH',
    'EAI_AGAIN',
];
exports.RETRY_CONFIG_DEFAULT = {
    maxRetry: 2,
    maxRevalidate: 1,
    retryAttempt: 0,
    revalidateAttempt: 0,
    delay: 100,
};
var isIdempotentMethod = function (method) {
    return method && IDEMPOTENT_HTTP_METHODS.includes(method);
};
exports.isIdempotentMethod = isIdempotentMethod;
var isNetworkError = function (error) {
    return (!error.response && (error.message === 'Network Error' || (!!error.code && RETRY_ERROR_CODES.includes(error.code))));
};
exports.isNetworkError = isNetworkError;
var isRetryableError = function (error) {
    var _a;
    if ((0, exports.isNetworkError)(error)) {
        return true;
    }
    var status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
    if (!status) {
        return false;
    }
    return RETRY_STATUS_RANGES.some(function (_a) {
        var min = _a[0], max = _a[1];
        return status >= min && status <= max;
    });
};
exports.isRetryableError = isRetryableError;
var backoffDelay = function (config, isExponential) {
    if (isExponential === void 0) { isExponential = false; }
    var delay = config.retryConfig.delay;
    if (isExponential) {
        // formula: (2^c - 1 / 2) * 1000
        delay = ((Math.pow(2, config.retryConfig.retryAttempt) - 1) / 2) * 1000;
    }
    delay = delay + delay * 0.2 * Math.random(); // randomization prevents several calls to happen at the same time
    return new Promise(function (resolve) {
        setTimeout(resolve, delay);
    });
};
exports.backoffDelay = backoffDelay;
var shouldRevalidateInstance = function (error) {
    return ((error === null || error === void 0 ? void 0 : error.response) && typeof error.response.status === 'number' && REVALIDATE_STATUSES.includes(error.response.status));
};
exports.shouldRevalidateInstance = shouldRevalidateInstance;
var shouldRetryRequest = function (error) {
    return (0, exports.isIdempotentMethod)(error.config.method) && (0, exports.isRetryableError)(error);
};
exports.shouldRetryRequest = shouldRetryRequest;
//# sourceMappingURL=retryUtils.js.map